import Numeral from 'numeral'

Numeral.register('locale', 'no', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal : function (number) {
    return number === 1 ? 'èn' : 'flere';
  },
  currency: {
    symbol: '§'
  }
})

Numeral.locale('no')

export default {

  methods: {
    format_ec(amount) {
      return Numeral(amount).format('$ 0,0[.]00')
    },

    format_ecs(amount) {
      if (amount < 1000) return Numeral(amount).format('$ 0,0')
      return `§ ${Numeral(amount).format('0.0a')}`
    },

    format_number(amount) {
      return Numeral(amount).format('0,0')
    }
  }

}
